import React from 'react'
import PropTypes from 'prop-types'
import { Table as AntTable } from 'antd'
import TableContainer from '../../shared/Table'
import { TableCount } from '../../common'

/**
 *
  Definition from back
 */

const columns = [
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email'
    // defaultSortOrder: 'descend',
    // sorter: (a, b) => (a.id - b.id)
  },
  {
    title: 'Nombre',
    dataIndex: 'first_name',
    key: 'first_name'
  },
  {
    title: 'Apellido',
    dataIndex: 'last_name',
    key: 'last_name'
  },
  {
    title: 'RUT',
    dataIndex: 'document',
    key: 'document'
  },
  {
    title: 'Fecha creación',
    dataIndex: 'createdIn',
    key: 'createdIn'
  },
  {
    title: 'Fecha actualización',
    dataIndex: 'updatedIn',
    key: 'updatedIn'
  }
]

class Table extends React.PureComponent {
  static displayName = 'CustomersTable'

  render () {
    const { data, loading, fetchMore, total, ...props } = this.props
    return (
      <TableContainer {...props}>
        {
          ({ onRow }) => (
            <>
              <TableCount count={total} />
              <AntTable
                {...props}
                loading={loading}
                className='bo-table'
                size='small'
                columns={columns}
                dataSource={data}
                pagination={false}
                onRow={(record, rowIndex) => onRow(record, rowIndex)}
              />
            </>
            
          )
        }
      </TableContainer>
    )
  }
}

Table.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  fetchMore: PropTypes.func,
  onRowClick: PropTypes.func,
  size: PropTypes.number,
  total: PropTypes.number
}

export default Table
